import * as React from "react";
const SvgScreen = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 3.754V18.375h9.381v2.246H7.314v1.506h9.372v-1.506H12.748v-2.246h9.381V3.754H12ZM3.38 5.252H20.62v9.625H3.38v-3.813z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgScreen;
